import React from 'react';
import { ModalContent, ModalFooter } from 'fronton-react';
import { ButtonWithGAClickButton, ModalHeader, Typography } from 'common/components';
import { fullWidthButton } from 'common/components/button/button-styles';
import { KITCHEN_ELEMENT_BLOCK } from '../../../../../kitchen-constants';
import { kitchenHeaderCardModalTitle } from '../../kitchen-header-card-styles';

export const Project = ({ onCloseModal, signUpHref }: { onCloseModal: () => void; signUpHref: string; }) => (
  <>
    <ModalHeader className={kitchenHeaderCardModalTitle} title="Сделаем бесплатный дизайн проект" />
    <ModalContent>
      <Typography variant="m" size="body_long">
        Наш дизайнер сделает проект кухни совершенно бесплатно: учтёт размеры, общий стиль интерьера и&nbsp;ваши пожелания&nbsp;&mdash; можно онлайн или в&nbsp;одном из&nbsp;магазинов Лемана ПРО.      </Typography>
    </ModalContent>
    <ModalFooter>
      <ButtonWithGAClickButton
        className={fullWidthButton}
        onClick={onCloseModal}
        elementBlock={KITCHEN_ELEMENT_BLOCK}
        elementName="Сделаем бесплатный дизайн проект"
        elementText="Записаться на проектирование"
        href={signUpHref}
        target="_blank"
        variant="accent"
        wide
      >
        Записаться на проектирование
      </ButtonWithGAClickButton>
    </ModalFooter>
  </>
);
